// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"ef282d28","211":"12ba6582","603":"28726958"}[chunkId] + ".chunk.css";
};